import { Building2, Home } from "lucide-react";
import { cn } from "@/lib/utils";

const PILL =
  "inline-flex items-center gap-1 rounded-full bg-white px-2 py-0.5 text-[11px] font-semibold text-brand-ink shadow-hairline";

// Realtor-listed pill (brokerage icon).
export default function BadgeRealtor({ className = "" }) {
  return (
    <span className={cn(PILL, className)}>
      <Building2 size={12} strokeWidth={2.5} className="text-brand-secondary" />
      Realtor
    </span>
  );
}

// Private owner pill — the private-lister counterpart to the realtor badge.
export function BadgeOwner({ className = "" }) {
  return (
    <span className={cn(PILL, className)}>
      <Home size={12} strokeWidth={2.5} className="text-brand-secondary" />
      Owner
    </span>
  );
}

// Picks the right pill from a listing's lister_type ("realtor" | "private").
// Anything that isn't a realtor is a private owner, so every listing now shows
// a lister badge beside the avatar (realtors read "Realtor", owners "Owner").
export function ListerBadge({ type, className = "" }) {
  return type === "realtor" ? (
    <BadgeRealtor className={className} />
  ) : (
    <BadgeOwner className={className} />
  );
}
